import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'MENUITEMS.MENU.TEXT',
        isTitle: true
    },
    {
        id: 2,
        label: 'MENUITEMS.DASHBOARDS.TEXT',
        icon: 'ri-dashboard-line',
        badge: {
            variant: 'success',
            text: 'MENUITEMS.DASHBOARDS.BADGE',
        },
        link: '/'
    },

    // ========== INVENTORY MANAGEMENT ==========
    {
        id: 2,
        label: 'Inventory Management',
        icon: 'ri-archive-line',
        subItems: [
            {
                id: 2.1,
                label: 'Products',
                subItems: [
                    { id: 2.11, label: 'Product List', link: '/product/productlist' },
                    { id: 2.12, label: 'Add Product', link: '/product/addnew' }
                ]
            },
            {
                id: 2.2,
                label: 'Categories',
                link: '/category/categories'
            },
            {
                id: 2.3,
                label: 'Stock Control',
                subItems: [
                    { id: 2.31, label: 'Stock List', link: '/stock/stocklist' },
                    { id: 2.32, label: 'Add Stock', link: '/stock/addStock' }
                ]
            },
            {
                id: 2.4,
                label: 'Suppliers',
                subItems: [
                    { id: 2.41, label: 'Supplier List', link: '/suppliers/supplierList' },
                    { id: 2.42, label: 'Add Supplier', link: '/suppliers/addnew' },
                    { id: 2.43, label: 'Supplier Ledgers', link: '/supplierLedger/ledgerList' }
                ]
            },
            {
                id: 2.5,
                label: 'Purchases',
                subItems: [
                    { id: 2.51, label: 'Purchase List', link: '/purchase/purchaselist' },
                    { id: 2.52, label: 'Purchase New', link: '/purchase/PurchaseProduct' },
                    { id: 2.53, label: 'Supplier Payments', link: '/purchase/SupplierPayments' }
                ]
            }
        ]
    },

    // ========== CLIENT MANAGEMENT ==========
    {
        id: 3,
        label: 'Client Management',
        icon: 'ri-team-line',
        subItems: [
            { id: 3.1, label: 'Our Clients', link: '/projectClients/clientList' },
            { id: 3.2, label: 'Clients Ledger', link: '/projectClients/clientLeadger' },
            { id: 3.3, label: 'Client Sites', link: '/projectClients/siteslist' },
            { id: 3.4, label: 'Client Sales', link: '/projectClients/ClientSaleslist' },
            { id: 3.5, label: 'New Sale', link: '/projectClients/newSale' },
            { id: 3.6, label: 'Reserve Sales', link: '/projectClients/reserveSales' },
        ]
    },

    // ========== USER MANAGEMENT ==========
    {
        id: 4,
        label: 'User Management',
        icon: 'ri-account-circle-line',
        subItems: [
            { id: 4.1, label: 'All Users', link: '/users/allusers' },
            { id: 4.2, label: 'Add New User', link: '/users/createuser' }
        ]
    },

    // ========== SYSTEM ==========
    {
        id: 5,
        label: 'System',
        icon: 'ri-settings-3-line',
        subItems: [
            { id: 5.1, label: 'Trash', link: '/trash/trashlist' }
        ]
    },

    ///////////////////////////////////////////////////////////////////////
    // {
    //     id: 52.5,
    //     label: 'Product Management',
    //     icon: 'ri-archive-line',
    //     subItems: [
    //         {
    //             id: 25.2,
    //             label: 'Products List',
    //             link: '/product/productlist',
    //             parentId: 52.5,
    //         },
    //         {
    //             id: 26.3,
    //             label: 'Add Product',
    //             link: '/product/addnew',
    //             parentId: 52.5,
    //         },
    //     ]
    // },
    // {
    //     id: 5.5,
    //     label: 'Order Management',
    //     icon: 'ri-truck-line',
    //     subItems: [
    //         {
    //             id: 25.2,
    //             label: 'Our Orders',
    //             link: '/order/orderlist',
    //             parentId: 5.5
    //         },
    //     ]
    // },
    // {
    //     id: 54.5,
    //     label: 'Returns & Exchanges',
    //     icon: 'ri-truck-line',
    //     subItems: [
    //         {
    //             id: 25.4,
    //             label: 'Return/Exchange',
    //             link: '/returnexchnages/returnlist',
    //             parentId: 54.5
    //         },
    //         {
    //             id: 26.5,
    //             label: 'Returns Products',
    //             link: '/returnexchnages/getReturn',
    //             parentId: 54.5
    //         },
    //         {
    //             id: 27.6,
    //             label: 'Exchange Products',
    //             link: '/returnexchnages/exchanges',
    //             parentId: 54.5
    //         },
    //         {
    //             id: 28.7,
    //             label: 'Manage Returns',
    //             link: '/returnexchnages/createReturnExch',
    //             parentId: 54.5
    //         },
    //     ]
    // },

    // {
    //     id: 3,
    //     label: 'Manage Categroy',
    //     icon: 'ri-stack-line',
    //     link: '/category/categories',
    // },
    // {
    //     id: 10.1,
    //     label: 'CataLog Category',
    //     icon: 'ri-layout-grid-line',
    //     subItems: [
    //         {
    //             id: 32.1,
    //             label: 'Category List',
    //             link: '/catalogCategory/fetchCategories',
    //             parentId: 10.1
    //         },
    //         {
    //             id: 32.2,
    //             label: 'Add New',
    //             link: '/catalogCategory/addnew',
    //             parentId: 10.1
    //         },
    //     ]
    // },

    // {
    //     id: 9.1,
    //     label: 'Our Brands',
    //     icon: 'ri-bill-line',
    //     subItems: [
    //         {
    //             id: 31.1,
    //             label: 'Brand List',
    //             link: '/brand/brandlist',
    //             parentId: 9.1
    //         },
    //         {
    //             id: 31.1,
    //             label: 'Add New',
    //             link: '/brand/addnew',
    //             parentId: 9.1
    //         },
    //     ]
    // },
    // {
    //     id: 58.5,
    //     label: 'Our Gifts',
    //     icon: 'ri-gift-line',
    //     subItems: [
    //         {
    //             id: 1.1,
    //             label: 'Gift List',
    //             link: '/gift/giftlist',
    //             parentId: 58.5
    //         },
    //         {
    //             id: 1.2,
    //             label: 'Add New',
    //             link: '/gift/addnew',
    //             parentId: 58.5
    //         },
    //     ]
    // },
    // {
    //     id: 14.1,
    //     label: 'Product Tags',
    //     icon: 'ri-price-tag-fill',
    //     subItems: [
    //         {
    //             id: 36.1,
    //             label: 'Tag List',
    //             link: '/tags/taglist',
    //             parentId: 14.1
    //         },
    //         {
    //             id: 36.2,
    //             label: 'Add Tag',
    //             link: '/tags/addnew',
    //             parentId: 14.1
    //         },
    //     ]
    // },
    // {
    //     id: 15.1,
    //     label: 'Reports & Analytics',
    //     icon: 'ri-file-chart-line',
    //     subItems: [
    //         {
    //             id: 37.1,
    //             label: 'KPI Overview',
    //             link: '/reports/kipOverview',
    //             parentId: 15.1
    //         },
    //         {
    //             id: 37.2,
    //             label: 'Daily Report',
    //             link: '/reports/dailyReport',
    //             parentId: 15.1
    //         },
    //         {
    //             id: 37.3,
    //             label: 'Monthly Report',
    //             link: '/reports/monthlyReport',
    //             parentId: 15.1
    //         },
    //         {
    //             id: 37.4,
    //             label: 'Payments Reports',
    //             link: '/reports/paymentBrakedown',
    //             parentId: 15.1
    //         },
    //         {
    //             id: 37.5,
    //             label: 'Returns Report',
    //             link: '/reports/returnsReports',
    //             parentId: 15.1
    //         },
    //         {
    //             id: 37.6,
    //             label: 'Status Report',
    //             link: '/reports/statusReports',
    //             parentId: 15.1
    //         },
    //         {
    //             id: 37.7,
    //             label: 'Top Customers',
    //             link: '/reports/topcustomers',
    //             parentId: 15.1
    //         },
    //         {
    //             id: 37.8,
    //             label: 'Top Products',
    //             link: '/reports/topProducts',
    //             parentId: 15.1
    //         },
    //     ]
    // },
    // {
    //     id: 11.1,
    //     label: 'Reviews',
    //     icon: 'ri-star-line',
    //     subItems: [
    //         {
    //             id: 33.1,
    //             label: 'Reviews List',
    //             link: '/reviews/allreviews',
    //             parentId: 11.1
    //         },
    //         {
    //             id: 33.2,
    //             label: 'Add Reviews',
    //             link: '/reviews/addnew',
    //             parentId: 11.1
    //         }
    //     ]
    // },

    // {
    //     id: 8.8,
    //     label: 'Customers (Clients)',
    //     icon: 'ri-user-3-line',
    //     subItems: [
    //         {
    //             id: 26.4,
    //             label: 'Client Managemnet',
    //             link: '/users/clientlist',
    //             parentId: 8.8
    //         },
    //     ]
    // },
    ///////////////////////////////////////////////////////////////////////////
    // {
    //     id: 4,
    //     label: 'Manage Users',
    //     icon: 'ri-account-circle-line',
    //     subItems: [
    //         {
    //             id: 1.1,
    //             label: 'Our All Users',
    //             link: '/users/allusers',
    //             parentId: 4
    //         },
    //         {
    //             id: 1.2,
    //             label: 'Add New User',
    //             link: '/users/createuser',
    //             parentId: 4
    //         },
    //     ]
    // },
    // {
    //     id: 5,
    //     label: 'Suppliers',
    //     icon: 'ri-store-line',
    //     subItems: [
    //         {
    //             id: 1.3,
    //             label: 'Our Suppliers',
    //             link: '/suppliers/supplierList',
    //             parentId: 5
    //         },
    //         {
    //             id: 1.4,
    //             label: 'Add New Supplier',
    //             link: '/suppliers/addnew',
    //             parentId: 5
    //         },
    //         {
    //             id: 1.9,
    //             label: 'Supplier Ledgers',
    //             link: '/supplierLedger/ledgerList',
    //             parentId: 5
    //         },
    //     ]
    // },
    // {
    //     id: 6,
    //     label: 'Trash',
    //     icon: 'ri-delete-bin-line',
    //     link: '/trash/trashlist',
    // },
    // {
    //     id: 7,
    //     label: 'Stock Control',
    //     icon: 'ri-store-2-line',
    //     subItems: [
    //         {
    //             id: 1.5,
    //             label: 'Stock List',
    //             link: '/stock/stocklist',
    //             parentId: 7
    //         },
    //         {
    //             id: 1.6,
    //             label: 'Add New',
    //             link: '/stock/addStock',
    //             parentId: 7
    //         },
    //     ]
    // },
    // {
    //     id: 8,
    //     label: 'Purchase Products',
    //     icon: 'ri-bank-card-line',
    //     subItems: [
    //         {
    //             id: 1.7,
    //             label: 'Purchases List',
    //             link: '/purchase/purchaselist',
    //             parentId: 7
    //         },
    //         {
    //             id: 1.8,
    //             label: 'Purchase New',
    //             link: '/purchase/PurchaseProduct',
    //             parentId: 7
    //         },
    //         {
    //             id: 1.9,
    //             label: 'Supplier Payments',
    //             link: '/purchase/SupplierPayments',
    //             parentId: 7
    //         },
    //     ]
    // },
    // {
    //     id: 9,
    //     label: 'Our Site Clients',
    //     icon: 'ri-bank-card-line',
    //     subItems: [
    //         {
    //             id: 2,
    //             label: 'Customer List',
    //             link: '/projectClients/clientList',
    //             parentId: 7
    //         },
    //         {
    //             id: 2.1,
    //             label: 'clients Leadger',
    //             link: '/projectClients/clientLeadger',
    //             parentId: 7
    //         },
    //     ]
    // },

    {
        id: 51,
        label: 'MENUITEMS.CALENDAR.TEXT',
        icon: 'ri-calendar-2-line',
        link: '/calendar'
    },
    // =========================Manage Website=========================================================
    {
        id: 30.1,
        label: 'Manage Website',
        icon: 'ri-global-line',
        subItems: [
            {
                id: 30.2,
                label: 'Home Slider',
                link: '/homeBanner/slider',
                parentId: 30.1
            },
            {
                id: 30.3,
                label: 'Manage About Us',
                link: '/AboutUs/getAboutUs',
                parentId: 30.1
            },
            {
                id: 30.4,
                label: 'Terms & Conditions',
                link: '/users/createuser',
                parentId: 30.1
            },
        ]
    },
];
